var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-work-environment wrap"},[_c('UiHeading',{attrs:{"h":'4',"type":'E2',"text":'職場環境に関すること'}}),_c('div',{staticClass:"box-cover"},_vm._l((_vm.boxes),function(box){return _c('UiBox1',{key:box.id,staticClass:"box",attrs:{"imgPath":box.imgPath,"subTitle":box.subTitle,"text":box.text}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }